import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Environment } from '../interfaces/environment.interface';
import { Response } from '../interfaces/response.interface';
import { SummaryOfTheYearData } from '../interfaces/summary-of-the-year-data.interface';
import { SummaryOfTheYearResponse } from '../interfaces/summary-of-the-year-response.interface';
import { Vehicle } from '../interfaces/vehicle.interface';
import { ENVIRONMENT } from '../tokens/environment.token';
import { ThemeService } from './theme.service';

@Injectable()
export class SummaryOfTheYearService {
	private environment: Environment = inject(ENVIRONMENT);
	private http: HttpClient = inject(HttpClient);
	private themeService = inject(ThemeService);

	public readonly year = 2025;

	public isSummaryOpen = signal<boolean>(false);

	public closeSummary(): void {
		const theme = this.themeService.currentTheme();
		if (theme) {
			this.themeService.applyThemeToDom(theme);
		}
		this.isSummaryOpen.set(false);
	}

	public getVehicles(): Observable<Vehicle[]> {
		return this.http
			.get<Response<Vehicle>>(this.environment.server + '/v2/machineMgmt/vehicles')
			.pipe(map((data: Response<Vehicle>) => (data.status ? data.data : [])));
	}

	public fetchData(serials: string[]): Observable<SummaryOfTheYearData> {
		const params = {
			serial: serials,
			from: 0,
			to: 0,
			res: 'dd',
			sum: serials.length < 3,
		};

		return this.http
			.post<SummaryOfTheYearResponse>(this.environment.server + '/v2/Stats/summary', params)
			.pipe(
				map((data: SummaryOfTheYearResponse) => {
					if (data.status) {
						return data.data;
					}
					return {} as SummaryOfTheYearData;
				})
			);
	}
}
